var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "#28D0D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 12.5333C11.8 12.2667 12.2 12.2667 12.4 12.5333L17.4 19.2C17.6472 19.5296 17.412 20 17 20H7C6.58798 20 6.35279 19.5296 6.6 19.2L11.6 12.5333Z",
    fill: "#59C390"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#528AA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompare);
export default __webpack_public_path__ + "static/media/icon-compare.d3235f33f40be94323c7275c7f0fbdbe.svg";
export { ForwardRef as ReactComponent };